const IntroDescription = () => <div className="text-left mt-4 max-w-3xl p-2 text-lg">
  <p>Keep your online accounts secure with our user-friendly Random Password
    Generator. Quickly and easily generate random, strong and unique passwords
    with a combination of letters, numbers, and special characters.</p>
</div>;

export default IntroDescription;